import { render, staticRenderFns } from "./ProfilePermission.vue?vue&type=template&id=7ad7bda8&scoped=true"
import script from "./ProfilePermission.vue?vue&type=script&lang=js"
export * from "./ProfilePermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad7bda8",
  null
  
)

export default component.exports